// import { API_RESPONSES } from '@/constants/api-response'
import { api } from '@/lib/api-manager'
import type { SignInType } from '@/pages/sign-in/hooks/use-sign-in'
// import { handleApiError } from '@/utils/handle-api-error'

// const responseStatusMessages = new Map<number, string>([
//   [401, API_RESPONSES.ERROR.INVALID_CREDENTIALS_ERRRO],
//   [500, API_RESPONSES.ERROR.SERVER_ERROR],
// ])

export async function signIn(data: SignInType) {
  // try {
  const response = await api.post('v1/auth/signin', data)
  return response.data
  // } catch (error) {
  //   handleApiError(error, responseStatusMessages)
  //   console.error(error)
  // }

  // return null
}
